<template>
    <div class="datetime">
        <div style="display:inline-block; float:left;">
            <input
            id="date"
            type="date"
            class="date"
            v-model="date"
            style="height:25px; width:210px;"
            @blur="sendData(true)"
            >
            <div style="float:left">
                <input
                id="hour"
                type="tel"
                class="count"
                v-model="time"
                style="height:25px"
                @blur="blurTime"
                @input="onChangeTime"
                onClick="this.setSelectionRange(0, this.value.length)"
                >
            </div>
        </div>
        <div style="float:left;">
            <button v-on:click="setNow()" style="height:30px; width:40px; float:left;"><font-awesome-icon icon="clock" /></button>
            <button v-on:click="addDay(-1)" style="height:30px; width:60px; float:left; font-weight:bold">-day</button>
            <button v-on:click="addHour(-1)" style="height:30px; width:50px; float:left; font-weight:bold">-hr</button>
            <button v-on:click="addHour(1)" style="height:30px; width:50px; float:left; font-weight:bold">+hr</button>
            <button v-on:click="addDay(1)" style="height:30px; width:60px; float:left; font-weight:bold">+day</button>
            <button v-if="use_X==true" v-on:click="setNull()" style="height:30px; width:40px; float:left;"><font-awesome-icon icon="times" /></button>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    name: 'datetime',
    props: {
        index:null,
        value: null,
        use_X:{
            type:Boolean,
            required:false,
            default:true
        },
    },

    data() {
        return {
            content: this.value,
            date: '',
            time:'',
            hour: '',
            minute: '',
        };
    },
    created(){
        if(this.content!=null && this.content!='null'){
            this.date = this.content.substr(0,10);
            this.hour = this.content.substr(11,2);
            this.minute = this.content.substr(14,2);
            this.time = this.hour + ':' + this.minute;
        }
    },
    methods: {
        setNow(){
            var now = new Date();
            this.date = now.getFullYear()+"-"+('00'+(now.getMonth()+1)).slice(-2)+"-"+('00'+now.getDate()).slice(-2);
            this.hour = ('00'+now.getHours()).slice(-2)
            this.minute = ('00'+now.getMinutes()).slice(-2)

            this.sendData(true);
        },
        setNull(changedManually=true){
            this.date = ''
            this.hour = ''
            this.minute = ''
            this.time='';

            this.sendData(changedManually);
        },
        addDay(amount){
            if(this.getDateTime()!=null){
                var newTime = new Date(this.getDateTime());
                newTime.setDate(newTime.getDate()+amount)

                this.date = newTime.getFullYear()+"-"+('00'+(newTime.getMonth()+1)).slice(-2)+"-"+('00'+newTime.getDate()).slice(-2);
                this.hour = ('00'+newTime.getHours()).slice(-2)
                this.minute = ('00'+newTime.getMinutes()).slice(-2)

                this.sendData(true);
            }
        },
        addHour(amount){
            if(this.getDateTime()!=null){
                var newTime = new Date(this.getDateTime());
                newTime.setHours(newTime.getHours()+amount)

                this.date = newTime.getFullYear()+"-"+('00'+(newTime.getMonth()+1)).slice(-2)+"-"+('00'+newTime.getDate()).slice(-2);
                this.hour = ('00'+newTime.getHours()).slice(-2)
                this.minute = ('00'+newTime.getMinutes()).slice(-2)

                this.sendData(true);
            }
        },
        onEnter() {
            this.sendData(true);
        },
        onChangeTime(){
            var match = this.time.match(/(\d{1,2}:\d{1,2})|(\d{1,2}:)|(\d{1,4})/)
            if(match!=null){
                this.time = match[0]
                if(this.time.length>=3){
                    this.time = this.time.substr(0,2).replace(/\D/g,'') + ":" + this.time.substr(2).replace(/\D/g,'')
                }
                this.time = this.time.substr(0,5);

                var split = this.time.split(":")
                if(split[0]!=null){
                    this.hour = split[0];
                }else{
                    this.hour = ''
                }
                if(split[1]!=null){
                    this.minute = split[1];
                }else{
                    if(this.hour!=''){
                        this.minute = '00'
                    }else{
                        this.minute = ''
                    }
                }
            }else{
                this.time=''
                this.hour = ''
                this.minute = ''
            }
        },
        blurTime() {
            this.onChangeTime();

            if(this.hour!='')
                this.hour = ('00'+this.hour).slice(-2);
            if(this.minute!='')
                this.minute = ('00'+this.minute).slice(-2);

            if(this.hour>23)
                this.hour=23;
            if(this.hour<0)
                this.hour=0;
            if(this.minute>59)
                this.minute=59;
            if(this.minute<0)
                this.minute=0;

            this.sendData(true);
        },
        sendData(changedManually){

            if(this.hour=='' || this.minute==''){
                this.time='';
            }else{
                this.time=this.hour+":"+this.minute;
            }


            this.content = this.getDateTime();

            this.$emit('input', this.content)
            this.$emit('inputIndex', this.index, this.content, changedManually)
        },
        getDateTime(){
            if(this.date!='' && this.date!=null){
                if(this.hour!='' && this.minute!=''){
                    return (this.date+' '+this.hour+':'+this.minute+':00');
                }else{
                    return (this.date+' 00:00:00');
                }

            }else{
                return null;
            }
        }
    },
    watch:{
		value: function (val, oldValue) {
            this.content = val;
            if(val != null && val != 'null' && val[1] != ':'){
                this.date = val.substr(0,10);
                this.hour = val.substr(11,2);
                this.minute = val.substr(14,2);
                this.time = (this.hour && this.minute) ? this.hour + ':' + this.minute : '';
            } else {
                this.date = '';
                this.hour = '';
                this.minute = '';
                this.time = '';
            }
		},
    }
};
</script>

<style>
.datetime {
    display:inline-block;
    width:800px;
}
.date {
    float:left;
    width: 300px;
}
.count {
    float:left;
    width:100px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/datetime.vue